angular.module('app.shared.clipCategoryService', [])
  .factory('app.shared.clipCategoryService', [
    '$http', '$q','$httpParamSerializerJQLike',
    function ($http, $q, $httpParamSerializerJQLike) {
      'use strict';

      let service = {
        getCategories: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`clips_categories?${options}`));
        },
        getCategory: (clip, categories) => {
          let deferred = $q.defer();

          if (Array.isArray(categories)) {
            deferred.resolve(service.getCategoryFromList(clip, categories));
          } else {
            service.getCategories()
              .then(
                (response) => {
                  deferred.resolve(service.getCategoryFromList(clip, response.data));
                },
                () => {
                  deferred.reject({error: 'Failed to retrieve categories'});
                }
              )
          }

          return deferred.promise;
        },
        getCategoryFromList: (clip, categories) => {
          let foundCategory = null;

          if (Array.isArray(categories)) {
            angular.forEach(categories, (category) => {
              if (clip.iclipcategoryid_fk == category.iclipcategoryid) {
                foundCategory = category;
                return false;
              }
            });
          }

          return foundCategory;
        },
        isType: (clipCategory, types) => {
          let isType = false;

          if (angular.isObject(clipCategory)) {
            if (!Array.isArray(types)) {
              types = [types];
            }

            angular.forEach(types, (type) => {
              let regex = new RegExp('^' + type, 'i');
              if (clipCategory.strclipcategory.match(regex)) {
                isType = true;
                return false;
              }
            });
          }

          return isType;
        },
        isTeam: (clipCategory, team) => {
          if (angular.isObject(clipCategory)) {
            team = team.toString().toLowerCase();

            let regex;

            switch (team) {
              case 'home':
                regex = new RegExp('(for|home)$', 'i');
                break;
              case 'away':
                regex = new RegExp('(against|away)$', 'i');
                break;
            }

            return clipCategory.strclipcategory.match(regex);
          }

          return false;
        },

        getSubcategories: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`clips_subcategories?${options}`));
        },

        getSubcategoryStrengths: (options) => {
          options = $httpParamSerializerJQLike(options);
          return $http.get(window.location.api(`clips_subcategory_strengths?${options}`));
        },
      };

      return service;
    }
  ])
;


// WEBPACK FOOTER //
// ./app.v2/components/shared/clipCategoryService.js